import { put, call, takeLatest, select } from 'redux-saga/effects';

import isEmpty from 'lodash/isEmpty';

import { formatError } from '../../../libs';
import publictionsAPI from '../../api/publications';
import { Creators, Types } from '../../reducers/attendance';
import { Creators as GlobalCreators } from '../../reducers/global';
import getState from '../../utils/getState';

function extractData(data) {
  const seo = data.find((item) => item.position === 'hotsiteconfig') || null;

  const menu = data.find((item) => item.position === 'sidebartop1') || null;

  const content = data.find((item) => item.position === 'contentmiddle1') || null;

  return {
    seo,
    menu,
    content,
  };
}

function* hotsiteAttendanceRequest({ query = 'central-de-atendimento' }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const data = yield call(publictionsAPI.hotsite, query, siteId);

    if (isEmpty(data)) throw 'Hotsite not found';

    yield put(Creators.hotsiteAttendanceSuccess(extractData(data)));
  } catch (error) {
    yield put(GlobalCreators.errorApp(formatError(error)));
    yield put(Creators.hotsiteAttendanceFailed(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.HOTSITE_ATTENDANCE_REQUEST, hotsiteAttendanceRequest);
}
